import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { authStateEnum } from "@/utils/enum";

class ConfirmHeader extends React.Component {
  constructor(props) {
    super(props);

    this.list = [
      {
        text: props.t("confirm_header_agreement"),
        image: "confirm-agreement",
      },
      {
        text: props.t("confirm_header_privacy_policy"),
        image: "confirm-privacy-policy",
      },
      {
        text: props.t("confirm_header_inquiry"),
        image: "confirm-inquiry",
      },
      {
        text: props.t("confirm_header_password"),
        image: "confirm-password",
      },
      {
        text: props.t(
          props.state === authStateEnum.notCertified
            ? "confirm_header_company"
            : // 課金-UPD-START
            props?.contractInfo?.isPayment
            ? "confirm_header_payment_user"
            : "confirm_header_user"
          // 課金-UPD-END
        ),
        image:
          props.state === authStateEnum.notCertified
            ? "confirm-company"
            : "confirm-user",
      },
    ];

    if (props.state === authStateEnum.notCertified) {
      this.list.splice(3, 0, {
        text: props.t("confirm_header_entry"),
        image: "confirm-entry",
      });
    }
    // 課金-ADD-START
    else if (props?.contractInfo?.isPayment) {
      this.list.splice(1, 0, {
        text: props.t("confirm_header_payment_agreement"),
        image: "confirm-agreement",
      });
    }
    // 課金-ADD-END
  }

  render() {
    const { stepIndex } = this.props;
    return (
      <div className="confirm-header-container">
        <img alt="" src={require("@/assets/images/confirm-logo.svg")} />
        <div className="confirm-header-container-stepper">
          {this.list.map((item, index) => (
            <React.Fragment key={index}>
              <div className="confirm-header-container-stepper-item">
                <img
                  alt=""
                  src={require(`@/assets/images/${item.image}${
                    index <= stepIndex ? "-selected" : ""
                  }.svg`)}
                />
                <div className="confirm-header-container-stepper-item-text">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.text,
                    }}
                  />
                </div>
              </div>
              {index < this.list.length - 1 ? (
                <div
                  className={`confirm-header-container-stepper-line ${
                    index < stepIndex ? "step-active" : ""
                  }`}
                />
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }
}

ConfirmHeader.propTypes = {
  stepIndex: PropTypes.number,
};

ConfirmHeader.defaultProps = {
  stepIndex: 0,
};

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    // 課金-ADD-START
    contractInfo: state?.user?.contractInfo,
    // 課金-ADD-END
  };
};

export default connect(mapStateToProps)(withTranslation()(ConfirmHeader));
